import React, {useState, useEffect} from 'react';
import {Text, View, TouchableOpacity, FlatList, StyleSheet, Dimensions} from 'react-native';
import AsyncStorage from '@react-native-async-storage/async-storage';
import {TTS_VERBOSITY} from '../../helpers/textToSpeech';
import ToolTip from '../../components/directPrinting/toolTip';
import i18n from 'i18n-js';

export default function VerbosityToggler({activeTollTip = '', handleTollTip = () => {}}) {
  const [selectedVerbosity, setSelectedVerbosity] = useState(TTS_VERBOSITY.LOCATION_QTY);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [tenantName, setTenantName] = useState('');
  const windowWidth = Dimensions.get('window').width;
  
  const verbosityOptions = [
    {label: i18n.t("verbosity.noAnnouncement"), value: TTS_VERBOSITY.NONE},
    {label: i18n.t("verbosity.locationOnly"), value: TTS_VERBOSITY.LOCATION_ONLY},
    {label: i18n.t("verbosity.locationAndQuantity"), value: TTS_VERBOSITY.LOCATION_QTY},
    {label: i18n.t("verbosity.skuLocationAndQuantity"), value: TTS_VERBOSITY.LOCATION_SKU_QTY},
    {label: i18n.t("verbosity.locationAndTotalQuantity"), value: TTS_VERBOSITY.LOCATION_QTY_TOTAL},
    {label: i18n.t("verbosity.skuLocationAndTotalQuantity"), value: TTS_VERBOSITY.LOCATION_SKU_QTY_TOTAL}
  ];

  useEffect(() => {
    const loadTenantAndVerbosity = async () => {
      try {
        const tenant = await AsyncStorage.getItem('tenant');
        if (tenant) {
          setTenantName(tenant);
        }
        const storageKey = tenant ? `ttsVerbosity_${tenant}` : 'ttsVerbosity';
        const savedVerbosity = await AsyncStorage.getItem(storageKey);
        if (savedVerbosity && Object.values(TTS_VERBOSITY).includes(savedVerbosity)) {
          setSelectedVerbosity(savedVerbosity);
        }
      } catch (error) {
        console.error('Failed to load settings:', error);
      }
    };

    loadTenantAndVerbosity();
  }, []);

  const changeVerbosity = async verbosity => {
    try {
      setSelectedVerbosity(verbosity);
      setIsDropdownOpen(false);
      const storageKey = tenantName ? `ttsVerbosity_${tenantName}` : 'ttsVerbosity';

      await AsyncStorage.setItem(storageKey, verbosity);
    } catch (error) {
      console.error('Failed to save verbosity setting:', error);
    }
  };

  const getSelectedLabel = () => {
    const option = verbosityOptions.find(opt => opt.value === selectedVerbosity);
    return option ? option.label : 'Location & Quantity';
  };

  return (
    <View style={[styles.container, {marginBottom: isDropdownOpen ? 200 : 20}]}>
      <View style={{display: 'flex', flexDirection: 'row', zIndex: 10, position: 'relative'}}>
        <TouchableOpacity 
          testID="infoIcon" 
          onPress={() => handleTollTip('VoicePickingTooltip')}
          style={{width: 20}}
        >
          <i
            className="icon-info-circled"
            style={{
              color: 'rgb(172,187,199)',
              fontSize: 17,
              height: 18,
            }}></i>
        </TouchableOpacity>
        <Text style={styles.heading}>
          {i18n.t("verbosity.label")}
        </Text>
        
        {activeTollTip === 'VoicePickingTooltip' && (
          <ToolTip
            testID="voice-picking-tooltip"
            top={25}
            left={-280}  
            windowWidth={windowWidth}
            message={i18n.t("verbosity.tollTip")}
            isLink={false}
            bodyTop={-20}
          />
        )}
      </View>

      <TouchableOpacity
        testID='verbosityToggler'
        onPress={() => {
          setIsDropdownOpen(!isDropdownOpen);
          if (activeTollTip === 'VoicePickingTooltip') {
            handleTollTip('');
          }
        }}
        style={styles.dropdownButton}>
        <Text style={styles.dropdownText}>
          {getSelectedLabel()}
        </Text>
      </TouchableOpacity>

      {isDropdownOpen && (
        <View style={styles.dropdownContainer}>
          <FlatList
            data={verbosityOptions}
            keyExtractor={item => item.value}
            renderItem={({item}) => (
              <TouchableOpacity
                testID={`verbosity-${item.value}`}
                onPress={() => changeVerbosity(item.value)}
                style={styles.dropdownItem}>
                <Text
                  style={[
                    styles.itemText,
                    selectedVerbosity === item.value && styles.selectedText
                  ]}>
                  {item.label}
                </Text>
              </TouchableOpacity>
            )}
          />
        </View>
      )}
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    padding: 20,
    paddingTop: 5,
    zIndex: 99
  },
  heading: {
    color: 'white',
    fontWeight: 600,
    fontSize: 16,
    marginBottom: 10,
    marginLeft: 10
  },
  dropdownButton: {
    width: 240,
    borderWidth: 1,
    borderColor: '#ddd',
    borderRadius: 5,
    padding: 10,
    backgroundColor: '#fff'
  },
  dropdownText: {
    color: '#000'
  },
  dropdownContainer: {
    position: 'absolute',
    top: 73,
    zIndex: 1,
    width: 240,
    backgroundColor: 'rgba(45, 68, 95, 1)',
    borderRadius: 5,
    elevation: 5
  },
  dropdownItem: {
  },
  itemText: {
    color: '#fff',
    padding: 10,
  },
  selectedText: {
    fontWeight: 'bold',
    backgroundColor: '#4b5f76',
  }
});
